var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FormText',{attrs:{"label":"Meeting","value":_vm.meetingPatternLabel,"disabled":""}}),_c('DynamicForm',{attrs:{"formId":_vm.formId,"editable":_vm.editable,"isNested":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }